export default function Reducer(prevState, action){
    switch (action.type) {
        case "LOADING":
            return {
                ...prevState, 
                loading: true
            }
        case "LOADED":
            return {
                ...prevState, 
                loading: false
            }
        case "SET_APPROVAL_PROCESS_STEPS":
            return {
                ...prevState, 
                approvalProcessSteps: action.approvalProcessSteps
            }
        case "SET_IDENTIFICATION_DETAILS":
            return {
                ...prevState, 
                identificationDetails: action.identificationDetails
            }
        case "INCREMENT_REFRESH_COUNT":
            return { 
                ...prevState, 
                refreshCount: prevState.refreshCount + 1 
            }
        case "SET_REFRESH_COUNT":
            return { 
                ...prevState, 
                refreshCount: action.refreshCount 
            }
        case "SET_SHOW_FTM_MAP":
            return {
                ...prevState,
                showFtmMap: action.showFtmMap
            }
        default:
            return prevState
    }
}